import { render, staticRenderFns } from "./VRCustomizeReport.vue?vue&type=template&id=7681d178"
import script from "./VRCustomizeReport.vue?vue&type=script&lang=js"
export * from "./VRCustomizeReport.vue?vue&type=script&lang=js"
import style0 from "./VRCustomizeReport.vue?vue&type=style&index=0&id=7681d178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports